import * as Yup from "yup";

export const cancelFormSchema = Yup.object().shape({
  cancellation_reason: Yup.string()
    .trim()
    .required("Cancellation Reason is required"),
});
